export default {
    pusherInstance: null,
    channels: {}
}